<template>
	<div class="page_padding header_body">

		<div class="finger" @click="toIndex">
			<img  style="height: 5vw;margin-top: 1vw;" src="../../assets/logo1.png" />
		</div>


		<div class="search_input">


			<el-cascader class="select_area" :options="options" v-model="selectedOptions"></el-cascader><input v-model="Search.word"
			 class="search_in" placeholder="请输入订单名称" />
			<div class="search_button" @click="toSearch">搜索</div>


			<div class="select_span">

				<span>热门搜索： 多媒体设计 室内设计 货运代理 供应链管理</span>

			</div>

		</div>

		<!-- <div class="header_contact"><span><i class="iconfont" style="font-size: 1.3vw;color:#ff481e">&#xe63a;</i>0756-2266692</span><span
			 style="margin-left: 5vw;"><i class="iconfont" style="font-size: 1.3vw;color:#ff481e">&#xe636;</i><a target = '_blank' href="http://wpa.qq.com/msgrd?v=3&uin=3341177121&site=qq&menu=yes" style="text-decoration: none;">在线qq客服</a></span></div> -->
	</div>
</template>

<script>
	import {
		regionData
	} from 'element-china-area-data'
	import {
		queryYumiOrder
	} from '../../api/cus.js'
	import {mapGetters} from 'vuex'
	import {toIndex} from '../../utils/index.js'
	export default {
		created() {
			let s = ""
			for (var o of regionData) {

				o.status = "none"
				o.type = "dq"
				o.children = null
				this.options.push(o)
				
			}
			
		},
		computed:{
			...mapGetters(['Search'])
		},
		
		data() {

			return {

				options: [],
				selectedOptions: [],
				selectArray: []
			}
		},
		methods: {
toIndex,
			toSearch() {
				
				let search = {
					dq:(this.selectedOptions.length>0)?this.options.find(item=>(item.value ==this.selectedOptions[0])).label:'',
					word:this.Search.word
				}
				this.$store.dispatch("SetSearch", search)

				this.$router.push({
					name: 'search'
				})

			},
			getDqObj(value) {
				for (let o of this.options) {
					if (o.value === value) return o
				}
			}
		

		},

	}
</script>

<style>
	.select_span {
		position: absolute;
		top: 9vw;
		color: #bebdbd;
		font-size: 1vw;
	}

	.header_contact {
		margin-top: 3vw;
		font-size: 1vw;
		color: #555555;

	}

	.search_button {
		width: 8vw;
		height: 3vw;
		background-color: #ff663e;
		border-radius: 2vw;
		border: solid 0vw #ff734c;
		line-height: 3vw;
		font-size: 1vw;
		color: #ffffff;
		text-align: center;
	}

	.header_body {

		display: flex;
		justify-content: space-between;
		background-color: #FFFFFF;
	}

	.search_input {
		margin-top: 2vw;
		width: 29vw;
		height: 3vw;
		background-color: #ffffff;
		border-radius: 2vw;
		border: solid 2px #ff734c;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.select_area {
		height: 1.5vw;
		color: #ff663e;
		border-radius: 2vw;
		border: 0px;
	}

	.select_area .el-input {
		height: 1.5vw;
	}

	.select_area .el-input__inner {
		height: 1.5vw;
		width: 5vw;
		color: #ff663e;
		border-radius: 2vw;
		border: 0px;
	}

	.el-cascader {

		line-height: 1.5vw;

	}

	.el-input__icon {
		line-height: 1.5vw;
	}

	.search_in {

		width: 12vw;
		height: 2.8vw;
		border: none;
	}

	.search_in:focus {
		border: none;
		outline: none;
	}

	input:focus {
		border: 1px solid #eb7350;

		background: #fff;

		outline: none;
	}
</style>
